import React from 'react'

export const BookIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="10"
    height="13"
    viewBox="0 0 10 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 10.25V2.75C1 2.41848 1.1317 2.10054 1.36612 1.86612C1.60054 1.6317 1.91848 1.5 2.25 1.5H8.5C8.63261 1.5 8.75979 1.55268 8.85355 1.64645C8.94732 1.74021 9 1.86739 9 2V11C9 11.1326 8.94732 11.2598 8.85355 11.3536C8.75979 11.4473 8.63261 11.5 8.5 11.5H2.25C1.91848 11.5 1.60054 11.3683 1.36612 11.1339C1.1317 10.8995 1 10.5815 1 10.25ZM1 10.25C1 9.91848 1.1317 9.60054 1.36612 9.36612C1.60054 9.1317 1.91848 9 2.25 9H9"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
